import CloseIcon from '@mui/icons-material/Close';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Checkbox, DialogActions, DialogContent, DialogTitle, ListItem, ListItemText } from '@mui/material';
import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog, CustomList } from '../../../components/StyledComponents';
import ImportDataDialog from '../UserManagement/ImportDataDialog';

const SelectDataToImportUsersDialog = ({ onClose }) => {
   const { t } = useTranslation();
   const [checkedItems, setCheckedItems] = useState({
      userProfileInfomation: true,
      userLocationRestrictions: false,
      biometrics: false,
      sendInvitation: false,
      sendDeviceRegistrationTokenWithEmail: false,
   });

   const [openImportSelectedEmployee, setOpenImportSelectedEmployee] = useState(false);

   const handleOpenImportSelectedEmployee = () => {
      setOpenImportSelectedEmployee(true);
   };

   const handleCloseImportSelectedEmployee = () => {
      setOpenImportSelectedEmployee(false);
   };

   return (
      <Fragment>
         <CustomDialog transitionDuration={300} maxWidth={'xl'} open onClose={onClose} keepMounted>
            <DialogTitle>
               <div className='flex justify-between'>
                  <div className='flex items-center gap-4'>
                     <p className='text-xl font-semibold '>{t('common.content-043')}</p>
                  </div>
                  <GrayIconButton onClick={onClose}>
                     <CloseIcon />
                  </GrayIconButton>
               </div>
            </DialogTitle>

            <DialogContent className='!py-0'>
               <div className='pt-5'>
                  <p>{t('common.content-044')}</p>
                  <div className='flex flex-col'>
                     <CustomList>
                        <ListItem>
                           <Checkbox
                              id='userProfileInfomation'
                              name='userProfileInfomation'
                              checked={checkedItems.userProfileInfomation}
                              onChange={() =>
                                 setCheckedItems({ ...checkedItems, userProfileInfomation: !checkedItems.userProfileInfomation })
                              }
                           />
                           <ListItemText primary={t('common.content-045')} />
                        </ListItem>
                        <ListItem className='!pl-10'>
                           <Checkbox
                              id='userLocationRestrictions'
                              name='userLocationRestrictions'
                              checked={checkedItems.userLocationRestrictions}
                              onChange={() =>
                                 setCheckedItems({ ...checkedItems, userLocationRestrictions: !checkedItems.userLocationRestrictions })
                              }
                           />
                           <ListItemText primary={t('common.content-046')} />
                        </ListItem>
                        <ListItem className='!pl-10'>
                           <Checkbox
                              id='biometrics'
                              name='biometrics'
                              checked={checkedItems.biometrics}
                              onChange={() => setCheckedItems({ ...checkedItems, biometrics: !checkedItems.biometrics })}
                           />
                           <ListItemText primary={t('common.biometrics')} />
                        </ListItem>
                     </CustomList>
                     <div className='bg-[#EFF6FF] rounded-md mb-5'>
                        <CustomList>
                           <ListItem>
                              <Checkbox
                                 id='sendInvitation'
                                 name='sendInvitation'
                                 checked={checkedItems.sendInvitation}
                                 onChange={() => setCheckedItems({ ...checkedItems, sendInvitation: !checkedItems.sendInvitation })}
                              />
                              <ListItemText primary={t('common.content-047')} />
                           </ListItem>
                           {checkedItems.sendInvitation && (
                              <ListItem className='!pl-10'>
                                 <Checkbox
                                    name='sendDeviceRegistrationTokenWithEmail'
                                    checked={checkedItems.sendDeviceRegistrationTokenWithEmail}
                                    onChange={() =>
                                       setCheckedItems({
                                          ...checkedItems,
                                          sendDeviceRegistrationTokenWithEmail: !checkedItems.sendDeviceRegistrationTokenWithEmail,
                                       })
                                    }
                                 />
                                 <ListItemText primary={t('common.content-048')} />
                              </ListItem>
                           )}
                        </CustomList>
                     </div>
                  </div>
               </div>
            </DialogContent>

            <DialogActions>
               <div className='flex gap-2 px-4 py-4'>
                  <ControlpanelSecondaryButton onClick={onClose}>
                     <CloseIcon />
                     <p>{t('button.close')}</p>
                  </ControlpanelSecondaryButton>
                  <ControlpanelPrimaryButton onClick={handleOpenImportSelectedEmployee}>
                     <PlayArrowIcon />
                     <p>{t('button.start-import')}</p>
                  </ControlpanelPrimaryButton>
               </div>
            </DialogActions>
         </CustomDialog>

         {openImportSelectedEmployee && <ImportDataDialog onClose={handleCloseImportSelectedEmployee} />}
      </Fragment>
   );
};

export default SelectDataToImportUsersDialog;
